module.exports = __webpack_public_path__ + "static/media/facebook.2f332489.svg";